var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{staticClass:"bg-white w-full flex flex-col"})}
var staticRenderFns = []

export { render, staticRenderFns }